export interface Service {
  id: string;
  title: string;
  categoryId: string;
  subCategory: string;
  image: string;
  summary: string;
  description: string;
  provider: string;
  publishedAt: string;
  region: string;
  type: string;
  tags: string[];
  rating: number;
  views: number;
  featured: boolean;
}

export const services: Service[] = [
  {
    id: 'e1',
    title: '零基础到进阶：Python数据分析实战训练营',
    categoryId: 'education',
    subCategory: '职业技能',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20online%20data%20analysis%20course%20scene%20with%20laptop%20showing%20charts%20and%20code%2C%20soft%20blue%20tones%2C%20minimal%20flat%20illustration%20style%2C%20bright%20study%20desk&width=640&height=400&seq=online-edu-01&orientation=landscape',
    summary: '12周体系化课程，从数据清洗到可视化，配套真实企业项目与作业批改。',
    description: '课程以真实业务数据为主线，覆盖 Python 基础语法、Pandas 数据处理、数据清洗与特征工程、Matplotlib 可视化以及完整分析报告撰写。每节课配有练习与讲师答疑，结课可获得实战项目作品集，适合零基础转行与在职提效人群。',
    provider: '星辰在线学院',
    publishedAt: '2026-09-28',
    region: '线上',
    type: '在线课程',
    tags: ['编程', '数据分析', '职业技能'],
    rating: 4.9,
    views: 12860,
    featured: true,
  },
  {
    id: 'e2',
    title: '成人英语口语速成：30天突破日常交流',
    categoryId: 'education',
    subCategory: '语言培训',
    image: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20English%20speaking%20practice%20scene%20with%20headphones%20and%20microphone%20on%20a%20clean%20desk%2C%20soft%20morning%20light%2C%20minimal%20illustration%20style%20with%20muted%20warm%20tones&width=640&height=400&seq=online-edu-02&orientation=landscape',
    summary: '情景对话+外教纠音，每天30分钟，帮你敢开口、说地道。',
    description: '课程围绕购物、出行、职场、社交四大高频场景设计情景对话，搭配 AI 发音评分与外教一对一点评。每周一次直播连麦练习，帮助学习者在真实交流中建立语感与自信，适合需要快速提升口语的成年学习者。',
    provider: '朗言语言中心',
    publishedAt: '2026-09-22',
    region: '线上',
    type: '在线课程',
    tags: ['英语', '口语', '语言培训'],
    rating: 4.7,
    views: 9430,
    featured: false,
  },
  {
    id: 'e3',
    title: '2026考研数学全程精讲班（全程答疑）',
    categoryId: 'education',
    subCategory: '考试考证',
    image: 'https://readdy.ai/api/search-image?query=Neat%20study%20desk%20with%20math%20notebook%2C%20pencil%20and%20open%20textbook%2C%20calm%20blue%20and%20cream%20tones%2C%20minimal%20flat%20illustration%2C%20bright%20academic%20atmosphere&width=640&height=400&seq=online-edu-03&orientation=landscape',
    summary: '高数、线代、概率三大模块系统精讲，配套真题与阶段测评。',
    description: '由一线考研名师讲授，从基础概念到解题技巧层层递进，配套近十年真题精讲、每周阶段测试与错题复盘。班级群内讲师全程答疑，帮助考生在有限时间内夯实数学基础、提升做题速度与准确率。',
    provider: '研途教育',
    publishedAt: '2026-09-15',
    region: '全国',
    type: '在线课程',
    tags: ['考研', '数学', '考试考证'],
    rating: 4.8,
    views: 15220,
    featured: true,
  },
  {
    id: 'n1',
    title: '城市音乐节周末特惠票',
    categoryId: 'entertainment',
    subCategory: '音乐活动',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20outdoor%20music%20festival%20crowd%20at%20sunset%20with%20stage%20lights%2C%20warm%20golden%20and%20blue%20tones%2C%20stylized%20illustration%2C%20energetic%20atmosphere&width=640&height=400&seq=online-ent-01&orientation=landscape',
    summary: '连续两晚多组乐队轮番开唱，双人票限时立减，含接驳巴士。',
    description: '本场音乐节集结十余组人气乐队与独立音乐人，涵盖流行、摇滚、民谣多种风格。活动设有美食市集与互动打卡区，购买双人票可享限时立减，并赠送往返市区接驳巴士名额，适合周末与好友一同前往放松。',
    provider: '橙光演出',
    publishedAt: '2026-09-30',
    region: '上海',
    type: '线下活动',
    tags: ['音乐节', '演出', '周末'],
    rating: 4.6,
    views: 8420,
    featured: true,
  },
  {
    id: 'n2',
    title: '亲子主题乐园年卡限时开放',
    categoryId: 'entertainment',
    subCategory: '主题乐园',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20joyful%20family%20theme%20park%20with%20carousel%20and%20ferris%20wheel%2C%20playful%20bright%20pastel%20tones%2C%20minimal%20flat%20illustration%2C%20sunny%20day&width=640&height=400&seq=online-ent-02&orientation=landscape',
    summary: '一家三口畅玩一年，含生日专属礼遇与优先入场通道。',
    description: '年卡覆盖园内全部常规游乐项目与主题演出，一年内不限次数入园。会员还可享受生日当月专属礼遇、热门项目优先入场通道与园内餐饮折扣，特别适合有孩子的家庭进行周末亲子活动。',
    provider: '欢乐星球乐园',
    publishedAt: '2026-09-26',
    region: '广州',
    type: '优惠活动',
    tags: ['亲子', '主题乐园', '年卡'],
    rating: 4.7,
    views: 11350,
    featured: false,
  },
  {
    id: 'n3',
    title: '高清影迷会：经典电影重映专场',
    categoryId: 'entertainment',
    subCategory: '影视演出',
    image: 'https://readdy.ai/api/search-image?query=Classic%20retro%20cinema%20interior%20with%20red%20seats%20and%20large%20screen%2C%20warm%20dim%20lighting%2C%20stylized%20illustration%2C%20nostalgic%20elegant%20atmosphere&width=640&height=400&seq=online-ent-03&orientation=landscape',
    summary: '4K修复版重映，映后设影评人交流环节，赠主题纪念票根。',
    description: '本专场精选多部影史经典进行 4K 修复重映，影厅采用高规格放映与环绕音效系统。每场放映结束后安排影评人与观众交流环节，现场赠送主题纪念票根与周边明信片，适合影迷深度参与。',
    provider: '幕间放映厅',
    publishedAt: '2026-09-18',
    region: '北京',
    type: '线下活动',
    tags: ['电影', '重映', '影迷'],
    rating: 4.5,
    views: 6210,
    featured: false,
  },
  {
    id: 's1',
    title: '国庆家电焕新季：满减叠加攻略',
    categoryId: 'shopping',
    subCategory: '限时折扣',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20appliance%20display%20with%20kitchen%20and%20cleaning%20devices%2C%20clean%20bright%20studio%20background%2C%20soft%20neutral%20tones%2C%20minimal%20product%20photography%20style&width=640&height=400&seq=online-shop-01&orientation=landscape',
    summary: '家电以旧换新叠加平台券，最高立省千元，附选购清单。',
    description: '活动期间选购冰箱、洗衣机、厨电等大件家电，可叠加以旧换新补贴、平台满减券与品牌直降三重优惠。页面整理了热门型号的到手价对照与选购要点，帮助用户在预算内选到高性价比产品。',
    provider: '购享商城',
    publishedAt: '2026-10-01',
    region: '全国',
    type: '优惠活动',
    tags: ['家电', '满减', '以旧换新'],
    rating: 4.8,
    views: 18620,
    featured: true,
  },
  {
    id: 's2',
    title: '国货美妆口碑好物精选清单',
    categoryId: 'shopping',
    subCategory: '品牌好物',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cosmetics%20and%20skincare%20products%20arranged%20on%20soft%20pink%20and%20cream%20background%2C%20clean%20minimal%20product%20photography%2C%20gentle%20soft%20lighting&width=640&height=400&seq=online-shop-02&orientation=landscape',
    summary: '实测百款国货美妆，按肤质与场景分类推荐，避坑不踩雷。',
    description: '编辑团队历时一个月实测上百款国货美妆与护肤产品，从成分、肤感、持妆力到性价比逐项打分。清单按干皮、油皮、敏感肌及通勤、约会等场景分类推荐，并附上真实使用心得与购买提醒。',
    provider: '好物研究室',
    publishedAt: '2026-09-24',
    region: '全国',
    type: '优惠活动',
    tags: ['美妆', '国货', '好物'],
    rating: 4.6,
    views: 13470,
    featured: false,
  },
  {
    id: 's3',
    title: '生鲜超市新用户专享大额券',
    categoryId: 'shopping',
    subCategory: '优惠券',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20colorful%20vegetables%20fruits%20and%20groceries%20in%20market%20baskets%2C%20bright%20clean%20background%2C%20fresh%20vibrant%20natural%20colors%2C%20minimal%20stylized%20photography&width=640&height=400&seq=online-shop-03&orientation=landscape',
    summary: '新用户立领大额满减券，下单再返通用券，次日达保新鲜。',
    description: '新用户注册即可领取多张生鲜满减券，首单满额再返通用无门槛券。平台与原产地供应商直连，支持冷链配送与次日达，主打时令蔬果、新鲜肉禽与半成品菜，帮助家庭更省心地完成日常采买。',
    provider: '鲜达生鲜',
    publishedAt: '2026-09-20',
    region: '杭州',
    type: '优惠活动',
    tags: ['生鲜', '优惠券', '新用户'],
    rating: 4.7,
    views: 9970,
    featured: false,
  },
  {
    id: 'l1',
    title: '专业保洁上门：深度清洁套餐',
    categoryId: 'life',
    subCategory: '家政保洁',
    image: 'https://readdy.ai/api/search-image?query=Clean%20tidy%20bright%20living%20room%20with%20cleaning%20supplies%20and%20gloves%2C%20soft%20natural%20light%2C%20minimal%20fresh%20illustration%20style%2C%20calm%20neutral%20tones&width=640&height=400&seq=online-life-01&orientation=landscape',
    summary: '持证保洁师上门，含厨房油污、卫浴除垢与玻璃擦拭全套服务。',
    description: '服务由经过培训并持证上岗的保洁师提供，覆盖厨房深度除油、卫浴除垢除霉、玻璃与地面清洁等区域。下单可选 2 小时、4 小时套餐，配备环保清洁用品，适用于新居开荒与日常深度维护。',
    provider: '净管家家政',
    publishedAt: '2026-09-27',
    region: '深圳',
    type: '到店服务',
    tags: ['保洁', '家政', '上门'],
    rating: 4.8,
    views: 7650,
    featured: false,
  },
  {
    id: 'l2',
    title: '家电维修24小时快速响应服务',
    categoryId: 'life',
    subCategory: '维修安装',
    image: 'https://readdy.ai/api/search-image?query=Technician%20repairing%20home%20appliance%20with%20toolbox%20and%20spare%20parts%2C%20clean%20bright%20workspace%2C%20minimal%20flat%20illustration%2C%20calm%20blue%20grey%20tones&width=640&height=400&seq=online-life-02&orientation=landscape',
    summary: '空调、洗衣机、冰箱等常见家电上门维修，先报价后维修。',
    description: '平台整合本地认证维修师傅，支持空调、洗衣机、冰箱、热水器等常见家电故障排查与维修。实行先检测报价、用户确认后再维修的流程，明码标价并提供维修质保，市区范围内可当天上门。',
    provider: '速修到家',
    publishedAt: '2026-09-12',
    region: '成都',
    type: '到店服务',
    tags: ['维修', '家电', '上门'],
    rating: 4.5,
    views: 5380,
    featured: false,
  },
  {
    id: 'l3',
    title: '同城搬家一口价：明码标价不踩坑',
    categoryId: 'life',
    subCategory: '搬家跑腿',
    image: 'https://readdy.ai/api/search-image?query=Movers%20carrying%20cardboard%20boxes%20and%20furniture%20into%20a%20moving%20van%2C%20bright%20clean%20daylight%2C%20minimal%20friendly%20illustration%2C%20warm%20neutral%20tones&width=640&height=400&seq=online-life-03&orientation=landscape',
    summary: '按里程与楼层透明计费，含打包材料与家具拆装，全程一口价。',
    description: '针对传统搬家临时加价的痛点，平台推行线上预估一口价模式，费用按车型、里程与楼层透明计算。服务包含基础打包材料、家具拆装与大件搬运，并支持物品保价，让用户搬家前就心里有数。',
    provider: '轻装搬家',
    publishedAt: '2026-09-08',
    region: '北京',
    type: '到店服务',
    tags: ['搬家', '一口价', '同城'],
    rating: 4.6,
    views: 6120,
    featured: false,
  },
  {
    id: 'h1',
    title: '三甲医生在线图文问诊',
    categoryId: 'health',
    subCategory: '在线问诊',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20doctor%20using%20tablet%20for%20online%20consultation%2C%20clean%20bright%20clinic%20background%2C%20soft%20calm%20blue%20and%20white%20tones%2C%20minimal%20illustration&width=640&height=400&seq=online-health-01&orientation=landscape',
    summary: '覆盖多科室执业医师，图文描述症状，平均10分钟内响应。',
    description: '平台汇集内科、外科、儿科、皮肤科等多科室执业医师，用户可通过图文方式描述症状并上传检查报告。医生在保护隐私的前提下给出初步分析与就医建议，帮助用户判断是否需要线下就诊，避免盲目就医。',
    provider: '康问在线',
    publishedAt: '2026-09-25',
    region: '线上',
    type: '在线咨询',
    tags: ['问诊', '健康', '在线'],
    rating: 4.7,
    views: 10430,
    featured: false,
  },
  {
    id: 'h2',
    title: '居家健身30天塑形计划',
    categoryId: 'health',
    subCategory: '健身指导',
    image: 'https://readdy.ai/api/search-image?query=Person%20doing%20home%20workout%20with%20yoga%20mat%20and%20dumbbells%20in%20bright%20living%20room%2C%20energetic%20soft%20natural%20light%2C%20minimal%20modern%20illustration&width=640&height=400&seq=online-health-02&orientation=landscape',
    summary: '无需器械，每日20分钟跟练，配套饮食建议与打卡社群。',
    description: '计划为无器械居家训练设计，每天 20 分钟跟练视频，循序渐进覆盖核心、臀腿与全身燃脂训练。配套每周饮食建议与动作要领讲解，并设有打卡社群互相鼓励，适合时间有限、希望在家养成运动习惯的人群。',
    provider: '燃刻健身',
    publishedAt: '2026-09-16',
    region: '线上',
    type: '在线课程',
    tags: ['健身', '塑形', '居家'],
    rating: 4.8,
    views: 12240,
    featured: true,
  },
  {
    id: 'h3',
    title: '注册营养师定制一周食谱',
    categoryId: 'health',
    subCategory: '营养饮食',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20balanced%20meal%20with%20vegetables%20grains%20and%20protein%20on%20light%20wooden%20table%2C%20fresh%20bright%20natural%20colors%2C%20clean%20food%20photography%20style&width=640&height=400&seq=online-health-03&orientation=landscape',
    summary: '根据体质与目标定制食谱，含采购清单与烹饪小贴士。',
    description: '由注册营养师根据用户的身体状况、口味偏好与减脂/增肌目标，定制一周三餐加餐食谱，并附采购清单与简单烹饪步骤。支持中途微调，帮助用户在不必挨饿的前提下，吃得均衡又方便执行。',
    provider: '食养研究所',
    publishedAt: '2026-09-10',
    region: '线上',
    type: '在线咨询',
    tags: ['营养', '食谱', '健康'],
    rating: 4.6,
    views: 7890,
    featured: false,
  },
  {
    id: 'c1',
    title: '大厂面试真题解析与模拟演练',
    categoryId: 'career',
    subCategory: '面试辅导',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20in%20a%20bright%20modern%20office%20interview%20setting%20with%20laptop%20notes%2C%20professional%20clean%20atmosphere%2C%20minimal%20blue%20grey%20illustration%20style&width=640&height=400&seq=online-career-01&orientation=landscape',
    summary: '覆盖互联网高频考点，真人模拟面试并给出逐题复盘建议。',
    description: '课程拆解互联网大厂高频面试考点，涵盖自我介绍、项目深挖、行为面试与技术追问四大环节。每位学员可预约一次真人模拟面试，由前大厂面试官逐题点评并给出改进方向，帮助求职者提升临场表达与应答逻辑。',
    provider: '职路课堂',
    publishedAt: '2026-09-23',
    region: '线上',
    type: '在线课程',
    tags: ['面试', '求职', '互联网'],
    rating: 4.9,
    views: 14760,
    featured: true,
  },
  {
    id: 'c2',
    title: 'HR视角简历优化诊断服务',
    categoryId: 'career',
    subCategory: '简历优化',
    image: 'https://readdy.ai/api/search-image?query=Resume%20document%20and%20clipboard%20with%20pen%20on%20clean%20desk%2C%20bright%20neat%20workspace%2C%20soft%20neutral%20blue%20tones%2C%20minimal%20professional%20illustration&width=640&height=400&seq=online-career-02&orientation=landscape',
    summary: '资深HR逐句批注简历，48小时内交付，附模板与话术建议。',
    description: '由具有多年招聘经验的 HR 从岗位匹配度、信息结构、成果量化与关键词优化四个维度逐句批注简历。48 小时内交付诊断报告，并附赠可编辑模板与自我评价话术建议，帮助求职者在简历环节更高效率地通过筛选。',
    provider: '简历工坊',
    publishedAt: '2026-09-14',
    region: '线上',
    type: '在线咨询',
    tags: ['简历', '求职', 'HR'],
    rating: 4.7,
    views: 9130,
    featured: false,
  },
  {
    id: 'c3',
    title: '热门城市互联网岗位直招专场',
    categoryId: 'career',
    subCategory: '求职招聘',
    image: 'https://readdy.ai/api/search-image?query=Modern%20bright%20office%20with%20diverse%20young%20professionals%20collaborating%2C%20clean%20professional%20atmosphere%2C%20minimal%20blue%20and%20warm%20grey%20illustration&width=640&height=400&seq=online-career-03&orientation=landscape',
    summary: '名企岗位集中放出，在线投递直通HR，附薪资区间参考。',
    description: '专场汇集一线城市互联网企业的技术、产品、运营、设计等热门岗位，支持在线投递并直通企业 HR。每个岗位附有薪资区间、班次与福利说明，用户可按城市与职能快速筛选，减少反复查找与盲目投递。',
    provider: '直聘直通车',
    publishedAt: '2026-09-29',
    region: '上海',
    type: '优惠活动',
    tags: ['招聘', '互联网', '求职'],
    rating: 4.5,
    views: 11280,
    featured: false,
  },
  {
    id: 't1',
    title: '2026旗舰手机选购避坑指南',
    categoryId: 'technology',
    subCategory: '选购指南',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphones%20lined%20up%20on%20clean%20minimal%20grey%20surface%2C%20studio%20product%20photography%2C%20soft%20neutral%20lighting%2C%20sleek%20premium%20look&width=640&height=400&seq=online-tech-01&orientation=landscape',
    summary: '横评影像、续航与性能，按预算分档推荐，看懂参数不花冤枉钱。',
    description: '指南对市面主流旗舰机型进行影像、性能、续航与系统体验的横向对比，用通俗语言解释芯片、屏幕与快充等参数的实际含义。按 3000、5000、7000 元三档预算给出推荐机型与适用人群，帮助用户理性决策。',
    provider: '数感测评',
    publishedAt: '2026-09-30',
    region: '线上',
    type: '工具推荐',
    tags: ['手机', '测评', '选购'],
    rating: 4.7,
    views: 15980,
    featured: true,
  },
  {
    id: 't2',
    title: '效率神器：10款必装AI办公工具',
    categoryId: 'technology',
    subCategory: 'AI应用',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20futuristic%20AI%20workspace%20with%20laptop%20and%20floating%20digital%20interface%20elements%2C%20soft%20blue%20and%20teal%20gradient%20tones%2C%20minimal%20stylized%20illustration&width=640&height=400&seq=online-tech-02&orientation=landscape',
    summary: '写作、制表、做图、会议纪要全覆盖，附免费额度与使用技巧。',
    description: '精选十款覆盖文案写作、数据处理、图片生成与会议纪要的 AI 办公工具，逐一介绍核心功能、免费额度与适用场景。每款工具附上上手技巧与常见限制说明，帮助职场人快速把 AI 融入日常办公流程，提升效率。',
    provider: '效率前沿',
    publishedAt: '2026-09-21',
    region: '线上',
    type: '工具推荐',
    tags: ['AI', '办公', '效率'],
    rating: 4.8,
    views: 17340,
    featured: true,
  },
  {
    id: 't3',
    title: '轻薄笔记本横评实测合集',
    categoryId: 'technology',
    subCategory: '数码测评',
    image: 'https://readdy.ai/api/search-image?query=Slim%20modern%20laptops%20on%20a%20clean%20bright%20desk%20with%20coffee%20and%20notebook%2C%20minimal%20studio%20photography%2C%20soft%20neutral%20warm%20grey%20tones&width=640&height=400&seq=online-tech-03&orientation=landscape',
    summary: '实测重量、续航与散热，覆盖办公与创作场景的真实体验。',
    description: '横评多款热门轻薄本，实测裸机重量、屏幕色域、续航表现与满载散热，并结合办公、剪辑与编程等真实场景给出体验结论。针对不同预算与使用需求提供选购建议，帮你在轻薄与性能之间找到平衡点，避免只看参数踩坑。',
    provider: '极客实验室',
    publishedAt: '2026-09-11',
    region: '线上',
    type: '工具推荐',
    tags: ['笔记本', '横评', '数码'],
    rating: 4.6,
    views: 10210,
    featured: false,
  },
  {
    id: 'r1',
    title: '周末周边露营地精选与预订',
    categoryId: 'travel',
    subCategory: '周边游',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20weekend%20glamping%20campsite%20with%20tents%20and%20string%20lights%20among%20green%20hills%2C%20warm%20sunset%20golden%20tones%2C%20minimal%20scenic%20illustration&width=640&height=400&seq=online-travel-01&orientation=landscape',
    summary: '精选车程两小时内的营地，含设施说明、价位与预订入口。',
    description: '精选城市周边车程两小时以内的优质露营地，逐一介绍营位类型、卫浴条件、可租赁装备与周边玩法。营地按亲子、情侣、团建等场景分类，附上真实价位与预订方式，让没有露营经验的人也能轻松安排一次周末出行。',
    provider: '野趣出行',
    publishedAt: '2026-09-27',
    region: '杭州',
    type: '线下活动',
    tags: ['露营', '周末', '周边游'],
    rating: 4.7,
    views: 8760,
    featured: true,
  },
  {
    id: 'r2',
    title: '国庆国内机票酒店预订优惠',
    categoryId: 'travel',
    subCategory: '机票酒店',
    image: 'https://readdy.ai/api/search-image?query=Airplane%20window%20view%20over%20clouds%20at%20sunrise%2C%20soft%20golden%20and%20blue%20sky%20tones%2C%20minimal%20serene%20travel%20illustration&width=640&height=400&seq=online-travel-02&orientation=landscape',
    summary: '热门目的地机酒打包立减，含改签权益与行李额度说明。',
    description: '面向国庆假期出行人群，提供热门目的地的机票酒店打包优惠，打包下单可比分开预订更省。产品明确标注改签退票规则与行李额度，避免出行前才发现隐藏限制，帮助用户把假期预算花在真正值得的体验上。',
    provider: '行知旅行',
    publishedAt: '2026-09-30',
    region: '全国',
    type: '优惠活动',
    tags: ['机票', '酒店', '国庆'],
    rating: 4.5,
    views: 13560,
    featured: false,
  },
  {
    id: 'r3',
    title: '小众目的地旅行攻略合集',
    categoryId: 'travel',
    subCategory: '旅行攻略',
    image: 'https://readdy.ai/api/search-image?query=Quiet%20scenic%20small%20town%20with%20stone%20streets%20and%20mountains%2C%20soft%20misty%20morning%20light%2C%20serene%20minimal%20illustration%2C%20muted%20natural%20tones&width=640&height=400&seq=online-travel-03&orientation=landscape',
    summary: '避开人潮的小众目的地清单，含交通、住宿与行程建议。',
    description: '合集收录多个风景宜人但游客相对较少的目的地，涵盖古镇、海岛与山野村落。每篇攻略提供交通方式、住宿选择、最佳季节与三日行程建议，并贴心地标注注意事项，适合想避开热门景点人潮、追求松弛旅行节奏的人。',
    provider: '漫游手记',
    publishedAt: '2026-09-19',
    region: '全国',
    type: '工具推荐',
    tags: ['攻略', '小众', '旅行'],
    rating: 4.8,
    views: 10620,
    featured: false,
  },
];